import { render, staticRenderFns } from "./HallEventDetailsCard.vue?vue&type=template&id=d22a7a96&scoped=true&"
import script from "./HallEventDetailsCard.vue?vue&type=script&lang=js&"
export * from "./HallEventDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./HallEventDetailsCard.vue?vue&type=style&index=0&id=d22a7a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22a7a96",
  null
  
)

export default component.exports